export default __webpack_public_path__ + "static/media/blogIcon.bcc33573.jpg";